import React, { Suspense, useEffect, CSSProperties, useState, useContext } from "react";
import {
  Navigate,
  RouteObject,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import Layout from "../components/layout";
import Home_ROUTES from "../screens/Home/routes";
import TERMS_ROUTES from "../screens/Terms/routes";
import PRIVACYPOLICY_ROUTES from "../screens/PrivacyPolicy/routes";
import LEGAL_ROUTES from "../screens/Legal/routes";
import FAQ_ROUTES from "../screens/FAQ/routes";
import ACCESSIBILITY_ROUTES from "../screens/Accessibilty/routes";
import CLIDASH_ROUTES from "../screens/ClientDashboard/routes";
import ADDCLIENT_ROUTES from "../screens/OnBoarding/routes";
import CUSTDASH_ROUTES from "../screens/CustomClientDashboard/routes";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import DashLayout from "../components/dashLayout";
import SCHEMEDASH_ROUTES from "../screens/SchemeDashboard/routes";
import DVCDASH_ROUTES from "../screens/DVCs/routes";
import { SCHEMEDASH_X_ROUTES } from "../screens/SchemeDashboard/routesTwo";
import { CLIDASH_X_ROUTES } from "../screens/ClientDashboard/routesTwo";
import { CLIENTCONFIGDASH_X_ROUTES } from "../screens/ClientConfigDashboard/routesTwo";
import DATA_AUDIT_ROUTES from "../screens/DataAudit/routes";
import HOMEDASH_ROUTES from "../screens/HomeDashboard/routes";
import DOCSANDDATA_ROUTES from "../screens/DocsAndData/routes";
import DATASCREEN_ROUTES from "../screens/DocsAndData/routesData";
import GMP_ROUTES from "../screens/GMPe/routes";
import ORIONAI_ROUTES from "../screens/OrionAIProforma/routes";
import GEMINI_ROUTES from "../screens/GeminiParent/routes";
import { UserContext } from "../context/UserContext";
import { useClientContext } from "../context/ClientContext";
import { getCurrentUserAsync } from "../api/api-routes";
import { useSchemeContext } from "../context/SchemeContext";
import DATA_MIGRATION_ROUTES from "../screens/DataMigrationParent/routes";
import CALCULATION_ROUTES from "../screens/CalculationsParent/routes";
import { useNotificationContext } from "../context/NotificationContext";
import DCS_PARENT_ROUTES from "../screens/DCS/routes";
import { scopes, siteurl } from "../../authConfig";
import ADMIN_ROUTES from "../screens/Admin/routes";
import ExternalLogin from "./ExternalLogin";

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

const containerStyle: CSSProperties = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
};

function AppRoutes() {
  const { accounts, instance } = useMsal();
  const { setConnectionTarget, connectionTarget  } = useNotificationContext();

  const [loading, setLoading] = useState(true);

  const { role, updateUserRole } = useContext(UserContext);
  const { updateClientType, updateClientIdContext, clientsSelectedIntellicaAdmin, updateClientSelectedIntellicaAdmin, updateClientSelectedNameIntellicaAdmin, clientType, clientIdContext } = useClientContext()
  const { updateSchemeAdminSchemeFilters, updateUserStatus, globalUserStatus } = useSchemeContext()

useEffect(() => {
  if (!accounts || accounts.length === 0) return;

  const account = accounts[0];

  const definedUserRole =
    account?.idTokenClaims?.extension_UserRole as string;

  if (definedUserRole) {
    updateUserRole(definedUserRole);
  }
}, [accounts]);

useEffect(() => {
  if (!accounts || accounts.length === 0) return;
  if (!role) return; 

  const account = accounts[0];

  const expirationTime = account?.idTokenClaims?.exp || 0;
  const currentTime = Math.floor(Date.now() / 1000);

  if (expirationTime && currentTime > expirationTime) {
    localStorage.clear();

    instance.logoutRedirect({
      account,
      postLogoutRedirectUri: `${siteurl}/public/home`,
    });

    return;
  }

  const handleLogout = () => {
    localStorage.clear();

    instance.logoutRedirect({
      account,
      postLogoutRedirectUri: `${siteurl}/public/home`,
    });
  };

  const INACTIVITY_LIMIT = 60 * 60 * 1000;
  let inactivityTimer: NodeJS.Timeout;

  const resetTimer = () => {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(handleLogout, INACTIVITY_LIMIT);
  };

  const activityEvents = [
    "mousemove",
    "mousedown",
    "keypress",
    "touchstart",
    "scroll",
  ];

  activityEvents.forEach((event) => {
    window.addEventListener(event, resetTimer);
  });

  resetTimer();

getCurrentUserAsync()
  .then((res: any) => {
    const data = res?.data;

    const clientSelectedIntellicaAdmin =
      data?.userClients?.map((j: any) => j.clientId) || [];

    const clientSelectedNameIntellicaAdmin =
      data?.userClients?.map((j: any) => j.clientName) || [];

    if (
      role === "IntellicaAdmin" &&
      clientSelectedIntellicaAdmin.length > 0
    ) {
      updateClientIdContext(clientSelectedIntellicaAdmin[0]);
    } else {
      data.clientId === null && clientIdContext === 0
        ? updateClientIdContext(1)
        : data.clientId === null && clientIdContext !== 0
        ? updateClientIdContext(clientIdContext)
        : data.clientId !== null
        ? updateClientIdContext(data.clientId)
        : updateClientIdContext(data.clientId);
    }

    data.clientName === null && clientType === ""
      ? updateClientType("Intellica")
      : data.clientName === null && clientType !== ""
      ? updateClientType(clientType)
      : data.clientName !== null
      ? updateClientType(data.clientName)
      : updateClientType(data.clientId);

    updateSchemeAdminSchemeFilters(data?.userSchemes);

    updateUserStatus(data?.userStatus);

    updateClientSelectedIntellicaAdmin(
      clientSelectedIntellicaAdmin
    );

    updateClientSelectedNameIntellicaAdmin(
      clientSelectedNameIntellicaAdmin
    );
  })
  .catch((err) => {
    console.log("An error occurred", err);
  });

  setConnectionTarget(connectionTarget);

  return () => {
    clearTimeout(inactivityTimer);
    activityEvents.forEach((event) => {
      window.removeEventListener(event, resetTimer);
    });
  };
}, [accounts, role, instance]);


useEffect(() => {
  const validateSession = async () => {
    const account = accounts?.[0];
    if (!account) return;

    try {
      await instance.acquireTokenSilent({
        account,
        scopes: scopes,
      });
    } catch (err: any) {
      console.warn("Silent auth failed, logging out", err);

      instance.logoutRedirect({
      account,
      postLogoutRedirectUri: `${siteurl}/public/home`,
    });
    }
  };

  validateSession();
}, [accounts]);

  const GLOBAL_ROUTES: RouteObject[] = [
    {
      element: <Layout />,
      children: [
        ...Home_ROUTES,
        ...TERMS_ROUTES,
        ...PRIVACYPOLICY_ROUTES,
        ...LEGAL_ROUTES,
        ...FAQ_ROUTES,
        ...ACCESSIBILITY_ROUTES
      ],
    },
   ...(import.meta.env.VITE_ENABLE_EXTERNAL_LOGIN === "true"
    ? [
        {
          path: "/login",
          element: <ExternalLogin />,
        },
      ]
    : []),
    {
      path: "*",
      element: <Navigate to={"/public/home"} replace />,
    },
  ];

  const PRIVATE_ROUTES: RouteObject[] = [
    {
      element: <DashLayout />,
           children: globalUserStatus === "Suspended" 
        ? [...HOMEDASH_ROUTES] 
        :
        role === "SchemeUser" ? 
        [  ...HOMEDASH_ROUTES,
          ...SCHEMEDASH_X_ROUTES,
          ...DOCSANDDATA_ROUTES,
          ...DATASCREEN_ROUTES,
          ...DATA_AUDIT_ROUTES,
          ...GMP_ROUTES,
          ...CALCULATION_ROUTES,
          ...DCS_PARENT_ROUTES,
          ...ORIONAI_ROUTES,
        ]
        :
        role === "SchemeAdmin" || role === "ClientAdmin" ? 
        [  ...HOMEDASH_ROUTES,
          ...SCHEMEDASH_X_ROUTES,
          ...CLIDASH_X_ROUTES,
          ...DOCSANDDATA_ROUTES,
          ...DATASCREEN_ROUTES,
          ...DATA_AUDIT_ROUTES,
          ...GMP_ROUTES,
          ...DATA_MIGRATION_ROUTES,
          ...CALCULATION_ROUTES,
          ...DCS_PARENT_ROUTES,
          ...ORIONAI_ROUTES,
        ]
        :
       [
        ...CLIDASH_ROUTES,
        ...CLIDASH_X_ROUTES,
        ...CLIENTCONFIGDASH_X_ROUTES,
        ...CUSTDASH_ROUTES,
        ...ADDCLIENT_ROUTES,
        ...DVCDASH_ROUTES,
        ...SCHEMEDASH_ROUTES,
        ...SCHEMEDASH_X_ROUTES,
        ...DATA_AUDIT_ROUTES,
        ...HOMEDASH_ROUTES,
        ...DOCSANDDATA_ROUTES,
        ...DATASCREEN_ROUTES,
        ...GMP_ROUTES,
        ...ORIONAI_ROUTES,
        ...GEMINI_ROUTES,
        ...DATA_MIGRATION_ROUTES,
        ...CALCULATION_ROUTES,
        ...DCS_PARENT_ROUTES,
        ...ADMIN_ROUTES
      ],
    },
    {
      path: "*",
      element: <Navigate to={"/private/home"} replace />,
    },
  ];

  const router = createBrowserRouter([...GLOBAL_ROUTES]);
  const private_router = createBrowserRouter([...PRIVATE_ROUTES]);

  return (
    <>
      <AuthenticatedTemplate>
        <Suspense>
          <div style={containerStyle}>
            <RouterProvider
              router={private_router}
              fallbackElement={
                <BeatLoader
                  color={"#81AED9"}
                  loading={loading}
                  cssOverride={override}
                  size={50}
                  aria-label="Loading Spinner"
                  data-test="loader"
                />
              }
            />
          </div>
        </Suspense>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Suspense>
          <div style={containerStyle}>
            <RouterProvider
              router={router}
              fallbackElement={
                <BeatLoader
                  color={"#81AED9"}
                  loading={loading}
                  cssOverride={override}
                  size={50}
                  aria-label="Loading Spinner"
                  data-test="loader"
                />
              }
            />
          </div>
        </Suspense>
      </UnauthenticatedTemplate>

 
    </>
  );
}

export default AppRoutes;
